<template>
  <ul id="menu-top" class="align-self-center">
    <template v-for="(item, index) in navItems">
        <template v-if="item.children">
          <!-- First level dropdown -->
          <li v-bind:key="index" class="have-submenu">
            <a href="#"><span>{{$t(item.name)}}</span> <i style="font-size:10px;" class="fas fa-chevron-down"></i></a>
            <ul class="submenu pop-up">
              <template v-for="(childL1, index) in item.children">
                <li v-bind:key="index">
                  <router-link v-if="checkMenuLicense(childL1)" :to="{name: childL1.url}" exact-path>
                    <span>{{$t(childL1.name)}}</span>
                  </router-link>
                  <a v-else role="link" class="cursor-pointer" aria-disabled="true" v-on:click="showMenuLicensePopup(childL1)">
                    <span>{{$t(childL1.name)}}</span>
                  </a>
                </li>
              </template>
            </ul>
          </li>
        </template>
        <template v-else>
          <li v-bind:key="index">
          <router-link v-if="checkMenuLicense(item)" :to="{name: item.url}" exact-path :disabled="checkMenuLicense(item)">
            <span>{{$t(item.name)}}</span>
          </router-link>
          <a v-else role="link" class="cursor-pointer" aria-disabled="true" v-on:click="showMenuLicensePopup(item)">
            <span>{{$t(item.name)}}</span>
          </a>
          </li>
        </template>
    </template>
  </ul>
</template>
<script>
import licenseHelpers from "../js/licenseHelpers";

export default {
  name: 'head-center-menu',
  mixins: [licenseHelpers],
  data:() => ( {
    navItems: []
  }),
  components: {
  },
  mounted() {
      this.navItems = this.$store.getters.getMenu;
  },
  methods: {},

}
</script>

<style lang="css">

</style>
